import { BaseWebComponentDataProvider } from '../../../../framework/BaseWebComponentDataProvider';
import { AvailableInProductTrialsDetails } from '../types/AvailableInProductTrialsDetails';
import { AvailableProductTrialType } from '../../types/AvailableProductTrialType';
import {
  FetchProductBuyInitialDataFunction,
  FetchProductBuyPriceFunction,
  FetchProductBuyUrlFunction,
} from '../../types/ProductLandingPageBuyConfig';

export abstract class InProductTrialsAppBaseDataProvider extends BaseWebComponentDataProvider {
  public abstract getAvailableInProductTrials(): Promise<AvailableInProductTrialsDetails>;

  public abstract startInProductTrial(
    type: AvailableProductTrialType
  ): Promise<{ success: boolean; errorMessage?: string }>;

  public abstract requestInProductTrial(
    type: AvailableProductTrialType,
    remarks?: string
  ): Promise<{ success: boolean; companyAlreadyProvisioned?: boolean; errorMessage?: string }>;

  public abstract cancelInProductTrial(
    type: AvailableProductTrialType
  ): Promise<{ success: boolean; errorMessage?: string }>;

  public abstract fetchProductBuyInitialData(
    ...args: Parameters<FetchProductBuyInitialDataFunction>
  ): ReturnType<FetchProductBuyInitialDataFunction>;

  public abstract fetchProductBuyPrice(
    ...args: Parameters<FetchProductBuyPriceFunction>
  ): ReturnType<FetchProductBuyPriceFunction>;

  public abstract fetchProductBuyUrl(
    ...args: Parameters<FetchProductBuyUrlFunction>
  ): ReturnType<FetchProductBuyUrlFunction>;
}
